import axiosInstance from "./AxiosInstance";

const BASE_URL = "/api/v3/residentes";

export const ResidenteService = {
  // ==================== VISITANTES ====================
  getVisitantes: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/visitantes/`, { params });
  },

  getVisitante: (slug) => {
    return axiosInstance.get(`${BASE_URL}/visitantes/${slug}/`);
  },

  // ==================== CORRESPONDENCIA ====================
  getCorrespondencia: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/correspondencia/`, { params });
  },

  getCorrespondenciaDetail: (slug) => {
    return axiosInstance.get(`${BASE_URL}/correspondencia/${slug}/`);
  },

  // ==================== PRE-REGISTROS ====================
  getPreRegistros: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/pre-registros/`, { params });
  },

  getPreRegistro: (slug) => {
    return axiosInstance.get(`${BASE_URL}/pre-registros/${slug}/`);
  },

  createPreRegistro: (data) => {
    return axiosInstance.post(`${BASE_URL}/pre-registros/`, data);
  },

  deletePreRegistro: (slug) => {
    return axiosInstance.delete(`${BASE_URL}/pre-registros/${slug}/`);
  },

  // ==================== AUTORIZACIONES ====================
  getAutorizaciones: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/autorizaciones/`, { params });
  },

  getAutorizacion: (slug) => {
    return axiosInstance.get(`${BASE_URL}/autorizaciones/${slug}/`);
  },

  getAutorizacionDetail: (slug) => {
    return axiosInstance.get(`${BASE_URL}/autorizaciones/${slug}/`);
  },

  createAutorizacion: (data) => {
    const formData = new FormData();

    Object.keys(data).forEach((key) => {
      if (data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    return axiosInstance.post(`${BASE_URL}/autorizaciones/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // ==================== ZONAS SOCIALES ====================
  getZonas: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/zonas/`, { params });
  },

  getReservas: (params = {}) => {
    return axiosInstance.get(`${BASE_URL}/reservas/`, { params });
  },

  getReserva: (uuid) => {
    return axiosInstance.get(`${BASE_URL}/reservas/${uuid}/`);
  },

  createReserva: (data) => {
    return axiosInstance.post(`${BASE_URL}/reservas/`, data);
  },

  cancelReserva: (uuid) => {
    return axiosInstance.delete(`${BASE_URL}/reservas/${uuid}/`);
  },
};

export default ResidenteService;
